import { Message } from "semantic-ui-react";
import { useEffect } from "react";
import { useFetch, useJSAForms } from "./JSAFormsFetchData";

import { JSAFormsContent } from "./JSAFormsContent";

export const JSAForms = () => {
    const {
        fetchData,
        loaded,
        error,
    } = useFetch();

    const {
        jsaForms,
        getJSAForms,
    } = useJSAForms(fetchData);

    useEffect(() => {
        getJSAForms();
    }, []);

    return (
        <div>
            {error !== '' &&
                <Message style={{ width: "fit-content" }} compact negative>{error}</Message>
            }
            <JSAFormsContent jsaForms={jsaForms} loaded={loaded} />
        </div>

    );
};
